<template>
  <ApolloMutation
    :mutation="(gql) => placeOrderQuery"
    :variables="{
      input: {
        id: orderId,
        phoneNumber: adminOrderDetails?.phoneNumber,
        alternativePhoneNumber: shippingInfo?.altPhoneNumber,
        placeId: shippingInfo?.placeId,
        addressDetails: shippingInfo?.addressDetails,
        schoolId: schoolInfo?.schoolId,
        studentName: schoolInfo?.studentName,
        studentClass: schoolInfo?.studentClass,
        forFullName: adminOrderDetails?.forName,
        forEmail: adminOrderDetails?.forEmail,
        eventId: adminOrderDetails?.eventId,
        ...(pdqTransactionId && {
          pdqTransactionId: pdqTransactionId,
        }),
        paymentMethod: paymentMethod,
        ...(b2bCustomerId && {
          b2bCustomerId,
          b2bDiscountOverride
        })
      },
    }"
    @done="onDone"
    @error="(error) => {
      loading = false;
      $store.dispatch('snackbar/showSnackbar', {
        text: error.message || $t('errors.unexpectedError'),
        color: 'error',
      });
    }"
  >
    <template #default="{ mutate }">
      <PrimaryButton
        id="submit"
        class="text-uppercase"
        block
        :disabled="loading || invalid"
        :loading="loading"
        @click="() => {
          loading = true;
          mutate();
        }"
      >
        {{ $t("checkout.form.placeOrder") }}
        <EkitabuIcon
          class="ml-2 has-glow"
          x-small
        >
          $triangleRight
        </EkitabuIcon>
      </PrimaryButton>
    </template>
  </ApolloMutation>
</template>

<script>
  import OrderQueries from "@/graphql/OrderQueries";
  import BookQueries from "@/graphql/BookQueries";
  import PrimaryButton from "@/components/buttons/PrimaryButton.vue";

  export default ({
    name: "PlaceOrderButton",
    components: {
      PrimaryButton,
    },
    props: {
      invalid: {
        type: Boolean,
        default: false,
      },
      shippingInfo: {
        type: Object,
        default: null,
      },
      schoolInfo: {
        type: Object,
        default: null,
      },
      isPickupOrder: {
        type: Boolean,
        default: false,
      },
      adminOrderDetails: {
        type: Object,
        default: null,
      },
      pdqTransactionId: {
        type: String,
        default: null,
      },
      b2bCustomerId: {
        type: String,
        default: null
      },
      b2bDiscountOverride: {
        type: Number,
        default: null
      },
      paymentMethod: {
        type: String,
        default: "cash"
      }
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      orderId() {
        return this.$store.state.cart.currentCart;
      },
      placeOrderQuery() {
        return OrderQueries.placeCashOrder;
      },
    },
    methods: {
      async onDone({ data }) {
        if (data.placeCashOrder.order.confirmed) {
          await this.$apollo.query({
            query: BookQueries.getUserBookshelf,
            fetchPolicy: "network-only",
          });
          this.$store.commit("setCurrentCart", null);
          this.loading = false;

          // Fetch full order details
          const orderId = data.placeCashOrder.order.id;
          const { data: orderData } = await this.$apollo.query({
            query: OrderQueries.getOrder,
            variables: { orderId }, // FIXED: use orderId, not id
            fetchPolicy: "network-only",
          });

          const orderDetails  = orderData.order;
          
          // --- Google Analytics Purchase Event ---
          window.gtag && window.gtag('event', 'purchase', {
            transaction_id: orderDetails.id,
            value: Number(orderDetails.totalPrice - orderDetails.totalTax),
            tax: Number(orderDetails.totalTax),
            coupon: orderDetails.orderCoupon?.code || undefined,
            currency: orderDetails.currency?._id,
            items: orderDetails.orderLines?.edges?.map(({ node }) => ({
              item_id: node.productId,
              item_name: node.name,
              price: Number(node.price),
            })),
          });  

          this.$router.push({
            name: "confirmed",
            params: {
              id: orderId,
            },
          });
        }
      },
    },
  });
</script>